<div>
  <ng-container *ngIf="dropdownType === 'multiple'">
    <ng-select
      #SelectId
      (change)="changeFn()"
      [items]="jobsBuffer$ | async"
      [multiple]="true"
      [closeOnSelect]="false"
      [searchable]="true"
      [clearable]="true"
      bindLabel="name"
      bindValue="id"
      [loading]="loading"
      [trackByFn]="trackByFn"
      [virtualScroll]="true"
      appearance="outline"
      placeholder="Select Jobs"
      [ngModelOptions]="{ standalone: true }"
      [editableSearchTerm]="true"
      [typeahead]="input$"
      (search)="searchProd($event)"
      (scrollToEnd)="scrollToEnd()"
      (open)="openDropdown($event)"
      (close)="closeDropdown($event)"
      (clear)="closeDropdown($event)"
      [(ngModel)]="selectedJobs">
      <ng-template ng-multi-label-tmp> {{ selectedJobs?.length }} jobs </ng-template>
      <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
        <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected" /> {{ item.name | uppercase }}
      </ng-template>
      <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
        <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected" /> {{ item.jobNumber }}
        {{ item.name }}
      </ng-template>
    </ng-select>
  </ng-container>

  <ng-container *ngIf="dropdownType === 'single'">
    <ng-select
      (change)="changeFn()"
      [items]="jobsBuffer$ | async"
      [closeOnSelect]="false"
      [searchable]="true"
      [trackByFn]="trackByFn"
      [virtualScroll]="true"
      [clearable]="false"
      bindLabel="name"
      bindValue="id"
      appearance="outline"
      placeholder="Select by name or job number"
      [ngModelOptions]="{ standalone: true }"
      (scrollToEnd)="scrollToEnd()"
      [typeahead]="input$"
      (search)="searchProd($event)"
      [clearable]="true"
      [(ngModel)]="selectedJobs">
      <ng-template ng-label-tmp let-item="item" let-item$="item$"> {{ item.jobNumber }} {{ item.name }} </ng-template>
      <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
        <span> {{ item.jobNumber }} {{ item.name }} </span>
      </ng-template>
    </ng-select>
  </ng-container>
</div>
